import IpsButton from './IpsButton.vue';
import '../../../styles/custom.scss';

export default IpsButton;
